import React from "react";
import Accordion from "react-bootstrap/Accordion";

function Faq() {
  const faqOptions = [
    {
      question: `Can I try SocialChimp before committing to a paid plan?`,
      answer: `Yes, we offer a free plan with limited access to AI capabilities. This plan is a great way to test the platform and see if it meets your needs before upgrading to a paid plan.`,
    },
    {
      question: `Are there any setup or installation fees?`,
      answer: `Zip. Nada. None.`,
    },
    {
      question: `Do you offer discounts for non-profit organizations or educational institutions?`,
      answer: `Reach out to our friendly team and let's chat about how we can help amplify your message without breaking your budget. Keep up the amazing work, and let's make some social media magic together!`,
    },
    {
      question: `Do you offer a free trial for any of the plans?`,
      answer: `Absolutely! We're all about giving you a chance to test drive our product. We've got a free plan that lets you send out up to 10 messages, just to get a taste of the SocialChimp magic. You'll get a sneak peek at our AI capabilities, though they'll be a bit limited in this plan. But don't fret! If you're digging the app and want to unlock every awesome feature we've got, you can easily upgrade to a full plan. That's when the real party starts - unlimited messages, full AI powers, and your social media history at your fingertips. Ready to take SocialChimp for a spin?`,
    },
    {
      question: `Can I upgrade or downgrade my plan at any time?`,
      answer: `Hey, we get it - flexibility is key! Feel like stepping up your social media game? Or maybe you want to take things down a notch? No problemo! You can head into our application at any time to upgrade or downgrade your plan - as easy as pie! But hold up - if you've signed up for a yearly commitment, things work a little differently. But don't sweat it, our awesome customer service team is ready to help you out. Just drop them a line and they'll assist you with the changes to your annual payment plan. So, no matter how your social media needs evolve, we've got your back!`,
    },
  ];

  return (
    <div className="faq-container">
      <Accordion alwaysOpen>
        {faqOptions.map((x, index) => {
          return (
            <Accordion.Item eventKey={`${index}`}>
              <Accordion.Header>{x.question}</Accordion.Header>
              <Accordion.Body>{x.answer}</Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}

export default Faq;
